import React from "react";
import { useState } from "react";
import s from "./PageInfo.module.css"
import docIco from "../../../assets/img/doc.svg"
import PageImg from "../../../assets/Behavior/4.jpg"
import logo from "../../../assets/Behavior/conceptions.jpg"
import { ArrowRightOutlined } from "@ant-design/icons"
import { DownOutlined } from "@ant-design/icons"
import { Hrefs } from "./PageInfoFRCKDN"
import { NavLink } from "react-router-dom";
import { hrefsArrFPF } from "../FilePage/FilesPublicationsForms";


const ChildDefence2020 = ({ url, header, children, style = {} }) => {
    return <div style={{ width: "1200px", margin: "0 auto" }} className={s.page}>
        <div className={s.content}>
            <div className={s.newHeader}>
                <h2>
                    Итоги Всероссийской научно-практической конференции «Актуальные проблемы профилактики девиантного поведения несовершеннолетних». 2020
                </h2>
                <p>
                    С 22 по 23 декабря 2020 г. федеральным государственным бюджетным учреждением «Центр защиты прав и интересов детей» по заказу Министерства просвещения Российской Федерации проведена Всероссийская научно-практическая конференция «Актуальные проблемы профилактики девиантного поведения несовершеннолетних», цель которой – обсуждение деятельности субъектов системы профилактики безнадзорности и правонарушений несовершеннолетних по актуальным проблемам в сфере профилактики девиантного поведения несовершеннолетних в современных социокультурных реалиях.
                </p><p>
                    Благодаря онлайн-формату в мероприятии приняли участие 2278 специалистов из 80 субъектов Российской Федерации. Это представители органов исполнительной власти субъектов РФ, осуществляющих государственное управление в сфере образования, ответственные за организацию психологического сопровождения образования и профилактику девиантного поведения, главные внештатные педагоги-психологи, педагоги-психологи и специалисты, ответственные за организацию мероприятий по профилактике девиантного и антисоциального поведения в общеобразовательных организациях, специалисты центров психолого-педагогической, медицинской и социальной помощи, представители профильных социально ориентированных некоммерческих организаций, родительское сообщество.
                </p><p>
                    На пленарных докладах обсуждались пути реализации приоритетных направлений государственной политики в сфере профилактики девиантного поведения несовершеннолетних, итоги реализации Концепции развития системы профилактики безнадзорности и правонарушений несовершеннолетних в 2017–2020 гг., ключевые задачи на ближайшие годы, актуальные проблемы развития системы профилактики, направленные на выработку разнообразных и инновационных подходов к образованию и воспитанию детей и подростков с учетом объективных социальных рисков.
                </p><p>
                    В ходе работы трех секций: «Профилактика социальных рисков: системный подход», «Профилактика девиантного поведения в образовательной среде», «Роль семьи в профилактике детских девиаций» был представлен опыт профилактической деятельности Вологодской области, г. Екатеринбурга и Свердловской области, Липецкой области, Пермского края, Республики Крым, Саратовской и Тюменской областей, Чувашской Республики.
                </p><p>
                    Большой интерес у участников конференции вызвали проведенные 23 декабря 2020 г., на второй день конференции, мастер-классы «Программа «Психолог детского коллектива» как инструмент в работе классного руководителя общеобразовательной организации» (ГАОУ ВО г. Москвы «Московский городской педагогический университет»), «Интерактивные методы профилактики школьной травли: программа «Каждый важен» (Еврейский музей и Центр толерантности) и онлайн-форум-спектакль «Мой друг – наркоман».
                </p><p>
                    По завершении мероприятия участники получили возможность внести предложения в резолюцию Всероссийской научно-практической конференции.
                </p><p>
                    Ссылки на доступ к мероприятиям Конференции доступны в программе Конференции.
                </p><p>
                    <a className={s.concepcA}
                        href="https://fcprc.ru/media/media/behavior/filemgr.uSpJoJ.2025-04-13_23_53_22.zip">Презентации докладов и мастер-классов</a>
                </p><p>
                    <a className={s.concepcA}
                        href="https://youtu.be/ibLxGfSG68I?si=z9Z_MhzS5fRSHk3y">Видео 1-й день</a>
                </p><p>
                    <a className={s.concepcA}
                        href="https://youtu.be/EkM--DyT3zM?si=iH02Pbpj2dJHsZ_W">Видео 2-й день</a>
                </p>
                <p></p>
            </div>
        </div>
        <div style={{ marginTop: "57px" }}>
            <HrefsBeh1 hrefsArr={hrefsArrFPF} />
            <WhiteButton text="Твое право" />


        </div>
    </div>


}

export const HrefsBeh1 = ({ hrefsArr, stylef = {}, to = "/" }) => {
    return <div className={s.hrefs} style={stylef}>
        <ul>
            {hrefsArr.map(el => <>
                <OneLiHrefs text={el.text} input={el.input} to={el.to} />
            </>)}
        </ul>

    </div>
}
const OneLiHrefs = ({ text, ul, input = null, to }) => {
    const [isActive, SetActive] = useState(false)

    return <>
        <li style={{ position: "relative", marginRight: "20px" }}>
            <div style={{ marginRight: "20px" }}>
                <img src={docIco} />
                <NavLink to={to}>
                    {text}
                </NavLink>
                {input ? <span
                    style={{ position: "absolute", right: "4px", padding: "3px", top: "10px" }}
                    onClick={() => {
                        isActive ? SetActive(false) : SetActive(true)
                    }} className={s.arrow}>
                    {!isActive ? <DownOutlined /> : <DownOutlined style={{ rotate: "180deg" }} />} </span>
                    : <></>}
            </div>
        </li>
        {isActive ? input.map(text => <OneLiHrefsInside text={text.text} to={text.to} />) : <></>}
    </>
}
const OneLiHrefsInside = ({ text, to }) => {
    return <NavLink to={to}>
        <li>
            {text}
        </li>
    </NavLink>
}
const PinkButton = ({ text, stylesheet }) => {
    return <div className={s.pinkbutton}>
        {text}

        <div>
            <ArrowRightOutlined />
        </div>
    </div>
}
const WhiteButton = ({ text, stylesheet }) => {
    return <div className={s.whitebutton}>
        {text}
        <div>
            <ArrowRightOutlined />
        </div>
    </div>
}

export default ChildDefence2020